import {
  Container,
  Link,
  List,
  ListItem,
  Paper,
  Typography,
} from '@mui/material';
import ReactMarkdown from 'react-markdown';

import { COUNTRIES, USERS } from '@wareclouds/frontend-common';
import { TERMS } from '@wareclouds/frontend-common/b2c';
import { CONTEXT } from '../../config/consts/commons';

const { CLOUDER } = USERS;

export default function Terms() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 4 }}>
        <ReactMarkdown
          components={{
            p: ({ children }) => (
              <Typography variant="body1" paragraph>
                {children}
              </Typography>
            ),
            ul: ({ children }) => (
              <List sx={{ listStyleType: 'disc', pl: 4 }}>{children}</List>
            ),
            li: ({ children }) => (
              <ListItem sx={{ display: 'list-item', py: 0 }}>
                <Typography variant="body1">{children}</Typography>
              </ListItem>
            ),
            a: ({ href, children }) => (
              <Link href={href} target="_blank" rel="noopener">
                {children}
              </Link>
            ),
          }}
        >
          {TERMS[CONTEXT]?.[CLOUDER] || TERMS[COUNTRIES.CL]?.[CLOUDER]}
        </ReactMarkdown>
      </Paper>
    </Container>
  );
}
